import type { MeshPhysicalMaterial } from 'three';

/** Opt-in visual crystal for photographed front caps and their edge material.
 * DOM camera is not a Three transmission texture. This keeps alpha transparent
 * while preserving live specular energy. Never apply to opaque temple materials.
 */
export function applyCrystalSurface(material: MeshPhysicalMaterial, enabled = false): void {
  if (!enabled || material.userData.mataCrystalSurface) return;
  material.userData.mataCrystalSurface = true;
  const baseOpacity = Math.max(material.opacity, 0.0001);
  const previousCompile = material.onBeforeCompile.bind(material);
  const previousCacheKey = material.customProgramCacheKey();
  material.transparent = true;
  material.depthWrite = false;
  material.onBeforeCompile = (shader, renderer) => {
    previousCompile(shader, renderer);
    shader.uniforms.mataCrystalBaseOpacity = { value: baseOpacity };
    shader.fragmentShader = 'uniform float mataCrystalBaseOpacity;\n' + shader.fragmentShader;
    shader.fragmentShader = shader.fragmentShader.replace('#include <opaque_fragment>', `
      float mataCrystalCos = clamp(abs(dot(normal, geometryViewDir)), 0.0, 1.0);
      float mataCrystalEdge = pow(1.0 - mataCrystalCos, 3.0);
      float mataCrystalFade = clamp(opacity / mataCrystalBaseOpacity, 0.0, 1.0);
      float mataCrystalAlpha = mix(diffuseColor.a, 0.72 * mataCrystalFade, mataCrystalEdge);
      vec3 mataCrystalDiffuse = totalDiffuse + totalEmissiveRadiance;
      #ifdef USE_CLEARCOAT
        mataCrystalDiffuse *= (1.0 - material.clearcoat * Fcc);
      #endif
      vec3 mataCrystalSpecular = max(outgoingLight - mataCrystalDiffuse, vec3(0.0));
      outgoingLight = mataCrystalDiffuse + mataCrystalSpecular * mataCrystalFade / max(mataCrystalAlpha, 0.06);
      diffuseColor.a = mataCrystalAlpha;
      #include <opaque_fragment>
    `);
  };
  material.customProgramCacheKey = () => `${previousCacheKey}:mata-crystal-A191`;
  material.needsUpdate = true;
}
